define('legacy/pp/shop',['jquery', 'legacy/navigation'], function($, navigation) {});

	var counterArr = [];

function PpCounter(timeToZero, trId, tdId, firstText, dayText, daysText, hourText,hoursText, minText,minsText, andText, secText,secsText) {
	'use strict';
	this.timeToZero = timeToZero;
	this.trId = trId;
	this.tdId = tdId;
	this.firstText = firstText;
	this.dayText = dayText;
	this.daysText = daysText;
	this.hourText = hourText;
	this.hoursText = hoursText;
	this.minText = minText;
	this.minsText = minsText;
	this.andText = andText;
	this.secText = secText;
	this.secsText = secsText;
}

function initCounter(timeToZero, trId, tdId, firstText, dayText, daysText, hourText, hoursText, minText, minsText, andText, secText, secsText) {
	'use strict';
	var counter = new PpCounter(timeToZero, trId, tdId, firstText, dayText, daysText, hourText, hoursText, minText, minsText, andText, secText, secsText);
	counterArr.push(counter);
}

function tickCounter() {
	'use strict';
	for (var i = 0; i < counterArr.length; i++) {
		var counter = counterArr[i];
		var oldTime = counter.timeToZero;

		var timeDD = 0;
		var timeHH = 0;
		var timeMM = 0;
		var timeSS = 0;
		var text = counter.firstText;
		if (counter.timeToZero <= 0) {
			var nodeDel = document.getElementById(counter.trId);
			nodeDel.parentNode.removeChild(nodeDel);
			counterArr.splice(i, 1);
			continue;
		}

		if (counter.timeToZero >= 1000 * 60 * 60 * 24) {
			timeDD = Math.floor(counter.timeToZero / (1000 * 60 * 60 * 24));
			if (timeDD > 1) {
				text = text + ' ' + timeDD + ' ' + counter.daysText;
			} else if (timeDD === 1) {
				text = text + ' ' + timeDD + ' ' + counter.dayText;
			}
		}

		if (counter.timeToZero >= 1000 * 60 * 60) {
			timeHH = Math.floor((counter.timeToZero - timeDD * 60 * 60 * 24 * 1000) / (1000 * 60 * 60));
			if (timeHH > 1) {
				text = text + ' ' + timeHH + ' ' + counter.hoursText;
			} else if (timeHH === 1) {
				text = text + ' ' + timeHH + ' ' + counter.hourText;
			}

		}

		if (counter.timeToZero >= 1000 * 60) {
			timeMM = Math.floor((counter.timeToZero - timeDD * 60 * 60 * 24 * 1000 - timeHH * 60 * 60 * 1000) / (1000 * 60));
			if (timeMM > 1 && (timeHH < 1 || timeDD < 1)) {
				text = text + ' ' + timeMM + ' ' + counter.minsText;
			} else if (timeMM === 1 && (timeHH < 1 || timeDD < 1)) {
				text = text + ' ' + timeMM + ' ' + counter.minText;
			}
		}

		timeSS = Math.floor((counter.timeToZero - timeDD * 60 * 60 * 24 * 1000 - timeMM * 60 * 1000 - timeHH * 60 * 60 * 1000) / 1000);

		if (counter.timeToZero < 60 * 1000) {
			if (timeSS > 1) {
				text = text + ' ' + timeSS + ' ' + counter.secsText;
			} else {
				text = text + ' ' + timeSS + ' ' + counter.secText;
			}
		}

		if (!document.getElementById(counter.tdId).firstChild) {
			document.getElementById(counter.tdId).appendChild(document.createTextNode(text));
		} else {
			document.getElementById(counter.tdId).firstChild.nodeValue = text;
		}

		counter.timeToZero = oldTime - 1000;
	}

}

function tickAllCounters() {
	'use strict';
	tickCounter();
}

function showLotteriesTab() {
	document.getElementById('tab-lottery').setAttribute('class', 'tab-active');
	document.getElementById('tab-bonuses').setAttribute('class',
			'tab-notactive');
	document.getElementById('tab-winners').setAttribute('class',
			'tab-notactive');
	document.getElementById('shop-lotteries').style.display = 'block';
	document.getElementById('shop-bonuses').style.display = 'none';
	document.getElementById('shop-item-ticket').style.display = 'none';
	document.getElementById('shop-item-footer').style.display = 'none';
	document.getElementById('all-lottery-winners').style.display = 'none';
	document.getElementById('shop-prize').style.display = 'none';

	document.getElementById('bonus-details').style.display = 'none';

	if (selectedBonus != undefined)
		if (document.getElementById('avb-dethide-' + selectedBonus) != null)
			if (document.getElementById('avb-dethide-' + selectedBonus).style.display == 'block')
				hideAvaBDetail(selectedBonus);

	document.getElementById('shop-winners').style.display = 'none';

	setIframeHeight();
}

// shows Bonuses tab
function showBonusesTab() {
	document.getElementById('tab-lottery').setAttribute('class',
			'tab-notactive');
	document.getElementById('tab-bonuses').setAttribute('class', 'tab-active');
	document.getElementById('tab-winners').setAttribute('class',
			'tab-notactive');
	document.getElementById('shop-lotteries').style.display = 'none';
	document.getElementById('shop-bonuses').style.display = 'block';
	document.getElementById('shop-item-ticket').style.display = 'none';
	document.getElementById('shop-item-footer').style.display = 'none';
	document.getElementById('all-lottery-winners').style.display = 'none';
	document.getElementById('shop-prize').style.display = 'none';

	document.getElementById('bonus-details').style.display = 'none';

	if (selectedBonus != undefined)
		if (document.getElementById('avb-dethide-' + selectedBonus) != null)
			if (document.getElementById('avb-dethide-' + selectedBonus).style.display == 'block')
				hideAvaBDetail(selectedBonus);

	document.getElementById('shop-winners').style.display = 'none';

	setIframeHeight();
}
// shows Lottery winners tab
function showWinnersTab() {
	document.getElementById('tab-lottery').setAttribute('class',
			'tab-notactive');
	document.getElementById('tab-bonuses').setAttribute('class',
			'tab-notactive');
	document.getElementById('tab-winners').setAttribute('class', 'tab-active');
	document.getElementById('shop-lotteries').style.display = 'none';
	document.getElementById('shop-bonuses').style.display = 'none';
	document.getElementById('shop-item-ticket').style.display = 'none';
	document.getElementById('shop-item-footer').style.display = 'none';
	document.getElementById('all-lottery-winners').style.display = 'none';
	document.getElementById('shop-prize').style.display = 'none';

	document.getElementById('bonus-details').style.display = 'none';

	if (selectedBonus != undefined)
		if (document.getElementById('avb-dethide-' + selectedBonus) != null)
			if (document.getElementById('avb-dethide-' + selectedBonus).style.display == 'block')
				hideAvaBDetail(selectedBonus);

	document.getElementById('shop-winners').style.display = 'block';

	setPageIndex(0);

	if (!successStoriesEmpty) {

		openSuccessStoriesDetails(escape(winnersArticleHeader),
				winnersArticleDate, escape(winnersArticleIntro),
				escape(winnersArticleInterview), escape(winnersArticleFooter),
				winnersImage, 0);
	} else {
		document.getElementById("winners-article-header").innerHTML = winnersArticleHeader;
		document.getElementById("winners-article-date").style.display = 'none';
		document.getElementById("winners-article-intro").innerHTML = winnersArticleIntro;
		document.getElementById("winners-article-interview").style.display = 'none';
		document.getElementById("winners-article-footer").style.display = 'none';
		document.getElementById("winners-image").style.display = 'none';
	}

	setIframeHeight();
}

function setIframeHeight() {
	window.top.reSizeBodyFrame(900);
	var totalheight = $(document).height();
	window.top.reSizeBodyFrame($(document).height());
}

// returns weeks, days, hours and minutes till next lottery draw
function calculateDrawDate(drawDate) {
	// timer will show 30 sec before a draw
	drawDate = drawDate - 30000;

	// get time till next draw
	var today = new Date();

	var formattedDrawDate = [];

	// drawDate is a timestamp
	// var diff = Math.abs(parseInt(drawDate) - today.getTime());
	var diff = parseInt(drawDate) - today.getTime();

	// end of draw
	if (diff < 0)
		return -1;

	weeks = Math.floor(diff / (60 * 60 * 24 * 7 * 1000));
	diff = diff - (weeks * (60 * 60 * 24 * 7 * 1000));

	var days = Math.floor(diff / (60 * 60 * 24 * 1000));
	diff = diff - (days * (60 * 60 * 24 * 1000));

	var hours = Math.floor(diff / (60 * 60 * 1000));
	diff = diff - (hours * (60 * 60 * 1000));

	var minutes = Math.floor(diff / (60 * 1000));
	diff = diff - (minutes * 60 * 1000);

	var secs = Math.floor(diff / (1000));

	formattedDrawDate.push(weeks);
	formattedDrawDate.push(days);
	formattedDrawDate.push(hours);
	formattedDrawDate.push(minutes);
	formattedDrawDate.push(secs);
	return formattedDrawDate;
}

// total number of tickets bought for a lottery
var totalBoughtTicketsJSON = {
	success : function(o) {
		var params = YAHOO.lang.JSON.parse(o.responseText);
		// if some exception happened, set total number of entries to empty
		if (isNaN(params.TOTAL_ENTRY)) {
            document.getElementById('totalEntries').innerHTML = '';
        } else {
            document.getElementById('totalEntries').innerHTML = params.TOTAL_ENTRY;
        }
	},
	failure : function(o) {

	},
	cache : false,
	timeout : 5000
};

// registration status of player (basic or fully registered)
var regStatusJSON = {
	success : function(o) {
		var params = YAHOO.lang.JSON.parse(o.responseText);

		// if some exception happened, set total number of entries to empty
		// sting
		regStatus = params.REG_STATUS;

		// if player is fully registered, he can buy a lottery ticket
		// otherwise, he must fully register first
		if (regStatus === 'real') {
			addPlayerPpLottery();
		} else {
			registration.openBasicToFull();
		}
	},
	failure : function(o) {
		'use strict';
		console.error('buyTickets failure:', o);
	},
	cache : false,
	timeout : 5000
};

// purchase ticket(s), if player is not fully registered, will
// be asked to do a full registration
function buyTickets() {
	// JSON call to get total registration status
	// needed since on submit of full registration reg status of player is changed
	YAHOO.util.Connect.asyncRequest('POST', domainUrl, regStatusJSON, 'flow=getRegStatus');
}

// all lottery winners for a lottery at the specific lottery draw date
var allLotteryWinnersJSON = {
	success : function(o) {

		var params = YAHOO.lang.JSON.parse(o.responseText);

		// IE fix
		var newTr = document.createElement("tr");

        var winnerTable = params.ALL_LOTTERY_WINNERS_LIST;
        winnerTable.replace("\\", "");
        newTr.innerHTML = winnerTable;

		var container = document.getElementById('allLotteryWinners');

		while (container.hasChildNodes()) {
			container.removeChild(container.lastChild);
		}
		// ff chrome
		if (navigator.appName != "Microsoft Internet Explorer") {
			container.innerHTML = winnerTable;
		} else {
//			IE
            if(getInternetExplorerVersion() < 10)
            {
                container.appendChild(newTr);
            }else{
                container.innerHTML = winnerTable;

            }

		}

		document.getElementById('all-lottery-winners').style.display = 'block';
		document.getElementById('shop-lotteries').style.display = 'none';

		// scroll up to the top, with chrome fix
		/*
		 * if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1)
		 * parent.window.scrollTo(0,0); else
		 * document.getElementById("top").focus();
		 */

		if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1)
			parent.window.scrollTo(0, 500);
		else
			document.getElementById("top_lottery_winners").focus();

		var totalheight = document.body.clientHeight;
		window.top.reSizeBodyFrame(totalheight);

	},
	failure : function(o) {
	},
	cache : false,
	timeout : 5000
};

function getInternetExplorerVersion()
// Returns the version of Internet Explorer or a -1
// (indicating the use of another browser).
{
    var rv = -1; // Return value assumes failure.
    if (navigator.appName == 'Microsoft Internet Explorer')
    {
        var ua = navigator.userAgent;
        var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
        if (re.exec(ua) != null)
            rv = parseFloat( RegExp.$1 );
    }
    return rv;
}

// returns all lottery winners for specific lottery and draw time
function getAllLotteryWinners(lotteryId, time) {
	// JSON call to get total number of bought tickets for a selected lottery
	YAHOO.util.Connect.asyncRequest('POST', domainUrl, allLotteryWinnersJSON,
			'flow=getAllLotteryWinners' + '&lotteryId=' + lotteryId + '&time='
					+ time);
}

// call to addPlayerPpLottery, which will populate equal number of
// rows in player_pp_lottery as player has bought tickets
function addPlayerPpLottery() {
	var ticketNumber = document.getElementById('ticketNumber').value;

	if (!validateTicketNumber(document.getElementById('ticketNumber'))) {
		return false;
	}

	YAHOO.util.Connect.asyncRequest('POST', domainUrl, serverDataCallBackFcn,
			'flow=addPlayerPpLottery' + '&ticketNumber=' + ticketNumber
					+ '&lotteryId='
					+ document.getElementById('lotteryId').value);
}

// time event for counter timer till next draw
var timeOut;

// timing event for player purchase ticket feed
var timeOutFeed;

// maximum number of potential lotteries that will be shown to player
var max_potential_list = 6;

function setupManualOrRegular(isManual, ticketPrice, lotteryId) {
    var $regularTicketPriceElement = $('#regular');
    var $manuallyTicketPriceElement = $('#manually');
    var $buyLotteryForm = $('#shop-item-form');
    if (isManual === 'true') {
        $manuallyTicketPriceElement.show();
        $regularTicketPriceElement.hide();
        $buyLotteryForm.hide();

        var numberOfTickets = lotteryIdToAmountOfTickets[lotteryId];
        var $priceElement = $manuallyTicketPriceElement.find("#number-tickets");
        if (numberOfTickets > 0) {
            $priceElement.text(numberOfTickets);
        } else {
            $priceElement.text(0);
        }
    } else {
        $manuallyTicketPriceElement.hide();
        $regularTicketPriceElement.show();
        $buyLotteryForm.show();

        $('#ticketPrice').text(ticketPrice);
        $('#ticketPriceTotal').text(ticketPrice);
    }
}

function openLotteryDetails(lotteryId, ticketPrice, eurPriceList, nextDrawDate,
		timeConst, lotteryName, lotteryDesc, largeImg, itemPrizeList,
		itemPrizeNameList, winValue, isManual) {

    setupManualOrRegular(isManual, ticketPrice, lotteryId);

	document.getElementById("no_potential").style.display = 'none';

	// timer for seconds till a drawing
	if (timeOut != undefined)
		clearTimeout(timeOut);

	var j = 0;

	// potential lotteries random subset :(
    var randomPotentialArray = randomizePotentialLotteries(lotteryId);

	// potential lotteries
	for ( var i = 0; i < potArray.length; i++) {

		// if lottery is not selected lottery and lottery is in random potential
		// lotteries array, show it
		if (lotteryId != potArray[i] && belongsInArray(i, randomPotentialArray)) {
			try {
				document.getElementById('lottery_' + potArray[i]).style.display = '';
			}
			// if lottery is removed from list due to drawing being done on it
			// do nothing
			catch (e) {
			}

			document.getElementById("no_potential").style.display = 'none';
			// display max 6 potential lotteries
			if (j >= max_potential_list)
				try {
					document.getElementById('lottery_' + potArray[i]).style.display = 'none';
				} catch (e) {
				}

			j++;
		} else {
			try {
				document.getElementById('lottery_' + potArray[i]).style.display = 'none';
			} catch (e) {
			}

			if (potArray.length == 1)
				document.getElementById("no_potential").style.display = '';
		}
	}

	// get a list of lottery prizes for a selected lottery
	allLotteryPrizes(lotteryId, eurPriceList, itemPrizeList, itemPrizeNameList);

	// Description of selected lottery
	document.getElementById('lotteryDescTextKey').innerHTML = lotteryDesc;

	// loading large img
	// document.getElementById('gold-ticket').style.background='url(static/img/shop-ticket-tmp.png)';
	document.getElementById('gold-ticket').style.background = 'url(' + largeImg
			+ ')';

	// JSON call to get total number of bought tickets for a selected lottery
	YAHOO.util.Connect.asyncRequest('POST', domainUrl, totalBoughtTicketsJSON,
			'flow=getTotalLotteryTicketsBought' + '&lotteryId=' + lotteryId);

	document.getElementById('lotteryId').value = lotteryId;

	eurPriceList = eurPriceList.split(',');

	var drawType = '';

	if (timeConst == 5)
		drawType = daylyDrawType;
	if (timeConst == 6)
		drawType = weeklyDrawType;
	if (timeConst == 7)
		drawType = monthlyDrawType;
	if (timeConst == 8)
		drawType = yearlyDrawType;
	if (timeConst == 9)
		drawType = quarterlyDrawType;

	if (timeConst == 10)
		document.getElementById('drawType').parentNode.style.visibility = 'hidden';
	else
		document.getElementById('drawType').parentNode.style.visibility = 'visible';

	document.getElementById('drawType').innerHTML = drawType;

	document.getElementById('shop-lotteries').style.display = 'none';
	document.getElementById('shop-item-ticket').style.display = 'block';
	document.getElementById('shop-item-footer').style.display = 'block';

	document.getElementById('lotteryName').innerHTML = lotteryName;
	document.getElementById('lotteryNameAgain').innerHTML = lotteryName;

	document.getElementById('winValue').innerHTML = winValue;



	// calculate time till next draw
	nextDrawIn(nextDrawDate, timeConst);

	// window.top.reSizeBodyFrame(document.body.clientHeight);
	setIframeHeight();

	return false;
}

// purchase result of the tickets, success or fail
var serverDataCallBackFcn = {
	success : function(o) {

		var params = YAHOO.lang.JSON.parse(o.responseText);

		if (params.RESULT == 'OK') {
			document.getElementById('popUpMessageOk').style.display = 'inline';
			document.getElementById('popUpMessageFailed').style.display = 'none';

			// purchase successful, show new balance
			document.getElementById('ppBalance').innerHTML = params.PP_BALANCE;
		} else if (params.RESULT == 'NOT_OK') {
			document.getElementById('popUpMessageOk').style.display = 'none';
			document.getElementById('popUpMessageFailed').style.display = 'inline';
		}

		// show popup message
		if (params.RESULT == 'NOT_OK' || params.RESULT == 'OK') {
			var x = document.getElementById("buyTicketPopUp");
			var panelHeaderComeOnShopConfirmation = shopConfirmation;
			window.top.showModalPanel(panelHeaderComeOnShopConfirmation,
					x.innerHTML, null, null, null, false, true);
			window.top.getTopWindowFocus();

			// show parent window
			document.getElementById('ticketNumber').value = '';
			showSymbol('PARAM_BUYTICKET', "fieldstatus-info");

			// if ticket is bought, show lottery tab, instead of default bonus
			// tab
			setCookie("c_shopTicketBought", "true", 365);
			window.location.reload();
		}

	},
	failure : function(o) {
	},
	cache : false,
	timeout : 5000
};

// Check if entered number of ticket is a positive number
function validateTicketNumber(o) {
    // number of tickets player wants to purchase
    var ticketCount = parseInt(o.value.replace(/\s+/g, '') , 10);

    var valid = true;

    // check if valid number of tickets is selected
    if (isNaN(ticketCount))
        valid = false;
    else if (ticketCount <= 0)
        valid = false;

	if (valid) {
		// check if player has enough points to purchase tickets
        var ticketCostString =  $('#ticketPriceTotal').text().replace(/\s+/g, '');
        var ticketCost = parseInt(ticketCostString, 10);
        var playerPointsBalance = parseInt(ppBalance.replace(/\s+/g, ''), 10);
        var totalTicketCost = ticketCost * ticketCount;

		if (totalTicketCost <= playerPointsBalance) {
			showSymbol('PARAM_BUYTICKET', "fieldstatus-ok");
			return true;
		} else {
			document.getElementById('temp').innerHTML = notEnoughPointsMsg;
			showSymbol('PARAM_BUYTICKET', "fieldstatus-error");
			return false;
		}
	} else {
		document.getElementById('temp').innerHTML = buyTicketsErrorMsg;
		showSymbol('PARAM_BUYTICKET', "fieldstatus-error");
		return false;
	}
}

// calculate next draw date every second
function nextDrawIn(nextDrawDate, timeConst) {

	var formattedDrawDate = calculateDrawDate(nextDrawDate);

	// end of draw, reload a page
	if (formattedDrawDate == -1) {
		window.location.reload();
		clearTimeout(timeOut);
		return;
	}
	;

	document.getElementById('nextDrawWeeks').innerHTML = formattedDrawDate[0];
	document.getElementById('nextDrawDays').innerHTML = formattedDrawDate[1];
	document.getElementById('nextDrawHours').innerHTML = formattedDrawDate[2];
	document.getElementById('nextDrawMinutes').innerHTML = formattedDrawDate[3];

	document.getElementById('nextDrawSeconds').innerHTML = formattedDrawDate[4];

	// hiding text where data is 0. i.e if weeks is 0, dont show it
	if (formattedDrawDate[0] == 0) {
		document.getElementById('nextDrawWeeks').style.display = 'none';
		document.getElementById('nextDrawWeeksText').style.display = 'none';
	} else {
		document.getElementById('nextDrawWeeks').style.display = '';
		document.getElementById('nextDrawWeeksText').style.display = '';
	}

	if (formattedDrawDate[1] == 0) {
		document.getElementById('nextDrawDays').style.display = 'none';
		document.getElementById('nextDrawDaysText').style.display = 'none';
	} else {
		document.getElementById('nextDrawDays').style.display = '';
		document.getElementById('nextDrawDaysText').style.display = '';
	}
	if (formattedDrawDate[2] == 0) {
		document.getElementById('nextDrawHours').style.display = 'none';
		document.getElementById('nextDrawHoursText').style.display = 'none';
	} else {
		document.getElementById('nextDrawHours').style.display = '';
		document.getElementById('nextDrawHoursText').style.display = '';
	}

	if (formattedDrawDate[3] == 0) {
		document.getElementById('nextDrawMinutes').style.display = 'none';
		document.getElementById('nextDrawMinutesText').style.display = 'none';
	} else {
		document.getElementById('nextDrawMinutes').style.display = '';
		document.getElementById('nextDrawMinutesText').style.display = '';
	}

	// time constant day=5; week=6; month=7; year=8; quarter=9; none=10;
	if (timeConst == 6) {

		// hide minutes and hours
		if (formattedDrawDate[0] != 0 && formattedDrawDate[1] != 0) {
			document.getElementById('nextDrawMinutes').style.display = 'none';
			document.getElementById('nextDrawMinutesText').style.display = 'none';
			document.getElementById('nextDrawHours').style.display = 'none';
			document.getElementById('nextDrawHoursText').style.display = 'none';
		}

		// hide minutes if combination of weeks days or hours (2 of 3) are >
		// then 0
		if ((formattedDrawDate[0] != 0 && formattedDrawDate[1] != 0)
				|| (formattedDrawDate[0] != 0 && formattedDrawDate[2] != 0)
				|| (formattedDrawDate[1] != 0 && formattedDrawDate[2] != 0)) {
			document.getElementById('nextDrawMinutes').style.display = 'none';
			document.getElementById('nextDrawMinutesText').style.display = 'none';
		}
	}
	if (timeConst == 7) {
		// hide minutes and hours
		if (formattedDrawDate[0] != 0 && formattedDrawDate[1] != 0) {
			document.getElementById('nextDrawMinutes').style.display = 'none';
			document.getElementById('nextDrawMinutesText').style.display = 'none';
			document.getElementById('nextDrawHours').style.display = 'none';
			document.getElementById('nextDrawHoursText').style.display = 'none';
		}

		// hide minutes if combination of weeks days or hours (2 of 3) are >
		// then 0
		if ((formattedDrawDate[0] != 0 && formattedDrawDate[1] != 0)
				|| (formattedDrawDate[0] != 0 && formattedDrawDate[2] != 0)
				|| (formattedDrawDate[1] != 0 && formattedDrawDate[2] != 0)) {
			document.getElementById('nextDrawMinutes').style.display = 'none';
			document.getElementById('nextDrawMinutesText').style.display = 'none';
		}
	}
	if (timeConst == 8) {
		// hide minutes, hours, days
		document.getElementById('nextDrawMinutes').style.display = 'none';
		document.getElementById('nextDrawMinutesText').style.display = 'none';
		document.getElementById('nextDrawHours').style.display = 'none';
		document.getElementById('nextDrawHoursText').style.display = 'none';
		document.getElementById('nextDrawDays').style.display = 'none';
		document.getElementById('nextDrawDaysText').style.display = 'none';
	}
	if (timeConst == 9) {
		// hide minutes and hours
		document.getElementById('nextDrawMinutes').style.display = 'none';
		document.getElementById('nextDrawMinutesText').style.display = 'none';
		document.getElementById('nextDrawHours').style.display = 'none';
		document.getElementById('nextDrawHoursText').style.display = 'none';
	}

	// always hide seconds except when weeks, days, hours are 0
	document.getElementById('nextDrawSeconds').style.display = 'none';
	document.getElementById('nextDrawSecondsText').style.display = 'none';

	if (formattedDrawDate[0] == 0 && formattedDrawDate[1] == 0
			&& formattedDrawDate[2] == 0) {
		document.getElementById('nextDrawSeconds').style.display = '';
		document.getElementById('nextDrawSecondsText').style.display = '';
	}
	// run calculate next draw time every second
	timeOut = setTimeout("nextDrawIn(" + nextDrawDate + ", " + timeConst + ")",
			1000);
}
var selectedBonus;

// open detailed information about an available bonus
function openBonusDetails(bonusId, bonusPpAmount) {
	// check if only one radio button is available
	// if that is the case, hide it and with a corresponding label
	// and set is as checked
	var arr = new Array();
	arr = document.getElementsByName("radio");
	var radioButtonCounter = 0;
	for ( var i = 0; i < arr.length; i++) {
		var obj = document.getElementsByName("radio").item(i);

		if (obj.value.indexOf(bonusId) != -1) {
			radioButtonCounter++;
			if (radioButtonCounter == 1)
				var candidateObj = obj;
		}
	}

	// only 1 radio button visible, hide it
	if (radioButtonCounter == 1) {
		candidateObj.checked = true;
		candidateObj.style.display = 'none';
		document.getElementById("label_" + bonusId).style.display = 'none';
	}

	document.getElementById("no_potential_bonus_" + bonusId).style.display = 'none';

	document.getElementById("bonusPpAmount_" + bonusId).innerHTML = bonusPpAmount;

	document.getElementById("shop-bonuses").style.display = 'none';
	document.getElementById("bonus-details").style.display = 'block';

	// don't reset radio buttons if we have 1 button scenario
	if (radioButtonCounter != 1)
		resetRadioButtons();

	// pop up value for take bonus (from Saldo)
	document.getElementById("b_e_f_pp").innerHTML = bonusPpAmount;
	document.getElementById("b_d_pp").innerHTML = bonusPpAmount;

	var j = 0;

	for ( var i = 0; i < bonusArray.length; i++) {
		if (bonusId != bonusArray[i]) {
			document.getElementById('ava-b-' + bonusArray[i]).style.display = 'none';

			document.getElementById('bonus_' + bonusId + '_' + bonusArray[i]).style.display = 'table-row';
			document.getElementById("no_potential_bonus_" + bonusId).style.display = 'none';
			// display max 3 potential lotteris
			if (j >= 3)
				document.getElementById('bonus_' + bonusId + '_'
						+ bonusArray[i]).style.display = 'none';
			j++;
		} else {
			document.getElementById('ava-b-' + bonusArray[i]).style.display = 'block';
			document.getElementById('bonus_' + bonusId + '_' + bonusArray[i]).style.display = 'none';
			if (bonusArray.length == 1)
				document.getElementById("no_potential_bonus_" + bonusId).style.display = '';
		}
	}
	// Hide all freespins
	$('li[id^="ava-f-"]').hide();
	selectedBonus = bonusId;
	setIframeHeight();
}

function openFreespinDetail(freespinId) {

	// Hide all freespins detail and show the present one
	var $freeSpinElement = $('#ava-f-' + freespinId + '');
	$freeSpinElement.siblings().hide();
	$freeSpinElement.show();
	// Hide the bonus/freespin overview and show the details
	$('#shop-bonuses').hide();
	$('#bonus-details').show();
	setIframeHeight();
}

function buyProductPromotion(freespinId, element) {
	//Removing onclick event, on the first click to prevent paying multiple times for a productPromotion.
	$(element).prop('onclick',null).off('click');

	var callback = function(response) {
		if (response.status == 'ok') {
			window.top.dialog.load('info', {
				title : response.messagetitle,
				heading : response.messagehead,
				message : response.message
			}, {}, function() {
				window.top.location.reload();
			});
		} else if(response.needsmobileverification !== undefined && (response.needsmobileverification === "true" || response.needsmobileverification === true)){
			window.top.showEmailMobileVerificationError(response.messagehead, response.message, response.verificationlink, response.latertext, true, null, null, response.messagehead);
		} else {
			window.top.dialog.load('error', {
				title : response.messagetitle,
				heading : response.messagehead,
				message : response.message
			});
		}

	};

	$.getJSON('pp?flow=BuyProductPromotionWithPoints&PRODUCT_PROMOTION_ID='
			+ freespinId, callback);

}

function toggleDetails(th, id) {
	var el = document.getElementById("p_" + id);
	var fp = document.getElementById("fp_" + id);
	var sp = document.getElementById("sp_" + id);

	th.innerHTML = (th.innerHTML.indexOf('-') > 0) ? ('<span>+</span>')
			: ('<span>-</span>');

	if (th.innerHTML.indexOf('-') > 0) {
		el.innerHTML = fp.value;
	} else {
		el.innerHTML = sp.value;
	}

	setIframeHeight();
}

function buyBonus(bonusId) {
	var radioItems = document.getElementsByName("radio");

	selectedRadio = -1;
	for ( var i = 0; i < radioItems.length; i++) {
		if (radioItems[i].checked == true) {
			selectedRadio = i;
		}
	}
	if (selectedRadio == -1) {
		bonusNoRadioSelectedErrorPopUp();
		return;
	}

	if (parseInt((document.getElementById("ppBalance").innerHTML).replace(/ /g,
			'') * 1) < parseInt((document.getElementById("bonusPpAmount_"
			+ bonusId).innerHTML).replace(/ /g, ''))) {
		bonusNoPpErrorPopUp();
		return;
	}

	if ((radioItems[selectedRadio].value)
			.indexOf("BUTTON_BONUS_GET_BONUS_DEPOSIT") != -1) {
		proceedCancelPopup(document
				.getElementById(radioItems[selectedRadio].value));
	} else {
		document.getElementById(radioItems[selectedRadio].value).onclick();
	}
}

// reset radio buttons
function resetRadioButtons() {
	var radioItems = document.getElementsByName("radio");

	for (var i = 0; i < radioItems.length; i++) {
		radioItems[i].checked = "";
	}
}

// in case of take bonus (deposits), show a popup
function proceedCancelPopup(radioButton) {

	var okCancel = function() {
		this.ok = function(o) {
			try {
				radioButton.onclick();
			} catch (e) {
				alert("error ok e:" + e);
			}
		};
		this.cancel = function(o) {
			try {
				// Do nothing
			} catch (e) {
				alert("error cancel e:" + e);
			}
		};
	};
	var okc = new okCancel();
	okc.run = window;

	var x = document.getElementById("bonusDepositPopUp");

	top
			.showOkCancelPanel(getText('HEADER_SHOP'), x.innerHTML, okc,
					null);
}

// in case of not enough points to buy a bonus, show a popup
function bonusNoPpErrorPopUp() {
	var okCancel = function() {
		this.ok = function(o) {
		};
		this.cancel = function(o) {
		};
	};
	var okc = new okCancel();
	okc.run = window;

	var x = document.getElementById("bonusNoPpErrorPopUp");

	top
			.showOkCancelPanel(getText('HEADER_SHOP'), x.innerHTML, okc,
					null);
}

// in case of not radio button is selected show a pop up
function bonusNoRadioSelectedErrorPopUp() {
	var okCancel = function() {
		this.ok = function(o) {
		};
		this.cancel = function(o) {
		};
	};
	var okc = new okCancel();
	okc.run = window;

	var x = document.getElementById("bonusNoRadioSelectedErrorPopUp");

	top
			.showOkCancelPanel(getText('HEADER_SHOP'), x.innerHTML, okc,
					null);
}

// get a list of lottery prizes for a selected lottery
function allLotteryPrizes(lotteryId, eurPrizeList, itemPrizeList, itemPrizeNameList) {

	var itemPrizeNameArray = [];

	if (itemPrizeNameList.length > 0 && itemPrizeNameList != 'null') {
		itemPrizeNameList = itemPrizeNameList.replace("[", ' ');
		itemPrizeNameList = itemPrizeNameList.replace("]", ' ');
		itemPrizeNameArray = itemPrizeNameList.split(',');
	}

	var itemPrizeArray = itemPrizeList.split(',');
	var lotteryPrizes = "<table width=\"100% border=\"0\" cellpadding=\"0\" cellspacing=\"0\">";

	// Item prizes
	count = itemPrizeNameArray.length;

	var j = 0;
    if (count <= 0) {
    } else {
        for (var i = 0; i < count; i++) {
            j = j + 1;
            lotteryPrizes += '<tr onclick="openPrizeDetails('
                + itemPrizeArray[i]
                + ')"><td width="20" class="prizes-number">#'
                + j
                + '</td><td class="prizes-value"><a href="#" onclick="return false;">'
                + itemPrizeNameArray[i]
                + '</a></td>'
                + '<td width="20"><img width="7" height="7" alt="" src="'
                + navigation.staticURL('img/arrow-right.gif') + '"></td></tr>';
        }
    }

	// Cash prizes
    if (eurPrizeList.length > 0) {
        $.each(aggregatePrizes(eurPrizeList.split(',')), function (index, prize) {
            lotteryPrizes += "<tr><td width=\"20\" class=\"prizes-number\">#"
                + ( index + 1 ) + "</td><td class=\"prizes-value\">" + '\u20AC'
                + prize + "</td><td width=\"20\"></td></tr>";
        });
    }

	// IE fix
	var newTr = document.createElement("tr");

	// newTr.innerHTML = params.ALL_LOTTERY_WINNERS_LIST;
	newTr.innerHTML = lotteryPrizes;

	var container = document.getElementById('allLotteryPrizes');

	while (container.hasChildNodes()) {
		container.removeChild(container.lastChild);
	}
	// ff chrome
	if (navigator.appName != "Microsoft Internet Explorer") {
		container.innerHTML = lotteryPrizes;
	} else {
		// IE
		container.appendChild(newTr);
	}
}

function aggregatePrizes(allPrizes) {
    var aggregatedPrizeAndCount = {};
    var lastPrize;
    $.each(allPrizes, function(index, prize) {
        var currentLength = Object.keys(aggregatedPrizeAndCount).length
        if (prize === lastPrize) {
            var lastPrizeArray = aggregatedPrizeAndCount[currentLength];
            aggregatedPrizeAndCount[currentLength][1] = lastPrizeArray[1] + 1
        } else {
            aggregatedPrizeAndCount[currentLength + 1] = [prize, 1];
            lastPrize = prize;
        }
    });

    var prizes = [];
    $.each(aggregatedPrizeAndCount, function(index, prizeArray) {
        if (prizeArray[1] > 1) {
            prizes.push(prizeArray.join(" x "));
        } else {
            prizes.push(prizeArray[0]);
        }
    });
    return prizes;
}

// Prize Details
var prizeDetailsJSON = {
	success : function(o) {

		var params = YAHOO.lang.JSON.parse(o.responseText);

		document.getElementById('prizeLargeImg').src = params.LARGE_IMG;
		document.getElementById('prizeName').innerHTML = params.NAME;
		document.getElementById('prizeNameFooter').innerHTML = params.NAME;
		document.getElementById('prizeDesc').innerHTML = params.DESC;

	},
	failure : function(o) {

	},
	cache : false,
	timeout : 5000
};

// Details about the prize, if the prize is not money
function openPrizeDetails(ppShopItemId) {

	// get info about prize from ppShopItemCat
	YAHOO.util.Connect.asyncRequest('POST', domainUrl, prizeDetailsJSON,
			'flow=getPpShopItemDetails' + '&ppShopItemId=' + ppShopItemId);

	document.getElementById('shop-item-ticket').style.display = 'none';
	document.getElementById('shop-item-footer').style.display = 'none';
	document.getElementById('shop-prize').style.display = 'block';

}
// back to lottery details screen from prize screen
function backLotteryDetails() {
	document.getElementById('shop-item-ticket').style.display = 'block';
	document.getElementById('shop-item-footer').style.display = 'block';
	document.getElementById('shop-prize').style.display = 'none';
}

// popup screen shown if user is not fully registered and wants to
// buy lottery tickets
function showBasicToFullReg(gameId, LoadPopUp) {
	window.top.registration.openBasicToFull();
	window.top.getTopWindowFocus();
}

// open detailed information about lottery winner (success stories)
function openSuccessStoriesDetails(headline, date, intro, interview, footer,
		resource, index) {
	document.getElementById("winners-article-header").innerHTML = unescape(headline);
	document.getElementById("winners-article-date").innerHTML = date;
	document.getElementById("winners-article-intro").innerHTML = unescape(intro);
	document.getElementById("winners-article-interview").innerHTML = unescape(interview);
	document.getElementById("winners-article-footer").innerHTML = unescape(footer);
	document.getElementById("winners-article-footer").style.fontWeight = 'bold';
	// document.getElementById("winners-image").innerHTML = resource;
	document.getElementById("winners-image").src = resource;

	// enable only one image arrow, hide others
	for (var i = 0; i < winnersArray.length; i++) {
		if (index == i) {
			document.getElementById('winner-arrow-id-' + i + '-s').style.display = 'block';
		} else {
			try {
				document.getElementById('winner-arrow-id-' + i + '-s').style.display = 'none';
			} catch (e) {
			}
		}
	}
    setIframeHeight();
}

/**
 * Methods for winners tab
 */
// max number of winners per page
var pageSize = 5;

function setPageIndex(index) {

	// Set the paging
	var page = 5;

	var pageMax = Math.ceil(winnersArray.length / pageSize);

	if (pageMax < page) { // We have to see if number of page is less than 5,
		// then we will use that number instead
		page = pageMax;
	}

	var pageHtml = "";

	if (pageMax > 1) {

		if (index == 0) { // When to the left
			pageHtml = pageHtml + "<li><a href=\"\" class=\"selected\">"
					+ (index + 1) + "</a><li/>";
			for ( var i = 1; i < page; i++) {
				pageHtml = pageHtml
						+ "<li><a href=\"\" onClick=\"setWinnerPage("
						+ (index + i) + ");return false;\">" + (index + 1 + i)
						+ "</a><li/>";
			}

			if (pageMax > page) { // If there are more than 5 pages we use
				// dots
				pageHtml = pageHtml + "...";
				pageHtml = pageHtml
						+ "<li><a href=\"\" onClick=\"setWinnerPage("
						+ (pageMax - 1) + ");return false;\">" + (pageMax)
						+ "</a><li/>";
			}
			if (pageMax - 1 > index) {
				pageHtml = pageHtml
						+ "<li><a href=\"\" onClick=\"setWinnerPage("
						+ (index + 1) + ");return false;\">Next</a><li/>";
			}
		} else if (index == 1) {
			pageHtml = pageHtml + "<li><a href=\"\" onClick=\"setWinnerPage("
					+ (index - 1) + ");return false;\">Previous</a><li/>";
			pageHtml = pageHtml + "<li><a href=\"\" onClick=\"setWinnerPage("
					+ (index - 1) + ");return false;\">" + (index)
					+ "</a><li/>";
			pageHtml = pageHtml + "<li><a href=\"\" class=\"selected\">"
					+ (index + 1) + "</a><li/>";
			for ( var i = 1; i < page - 1; i++) {
				pageHtml = pageHtml
						+ "<li><a href=\"\" onClick=\"setWinnerPage("
						+ (index + i) + ");return false;\">" + (index + i + 1)
						+ "</a><li/>";
			}
			if (pageMax > page) { // If there are more than 5 pages we use
				// dots
				pageHtml = pageHtml + "...";
				pageHtml = pageHtml
						+ "<li><a href=\"\" onClick=\"setWinnerPage("
						+ (pageMax - 1) + ");return false;\">" + (pageMax)
						+ "</a><li/>";
			}
			if (pageMax - 1 > index) {
				pageHtml = pageHtml
						+ "<li><a href=\"\" onClick=\"setWinnerPage("
						+ (index + 1) + ");return false;\">Next</a><li/>";
			}

		} else if (index == pageMax - 2) { // When on the second last
			pageHtml = pageHtml + "<li><a href=\"\" onClick=\"setWinnerPage("
					+ (index - 1) + ");return false;\">Previous</a><li/>";
			if (index - 3 >= 0) {
				pageHtml = pageHtml
						+ "<li><a href=\"\" onClick=\"setWinnerPage("
						+ (index - 3) + ");return false;\">" + (index - 2)
						+ "</a><li/>";
			}
			pageHtml = pageHtml + "<li><a href=\"\" onClick=\"setWinnerPage("
					+ (index - 2) + ");return false;\">" + (index - 1)
					+ "</a><li/>";
			pageHtml = pageHtml + "<li><a href=\"\" onClick=\"setWinnerPage("
					+ (index - 1) + ");return false;\">" + (index)
					+ "</a><li/>";
			pageHtml = pageHtml + "<li><a href=\"\" class=\"selected\">"
					+ (index + 1) + "</a><li/>";
			pageHtml = pageHtml + "<li><a href=\"\" onClick=\"setWinnerPage("
					+ (index + 1) + ");return false;\">" + (index + 2)
					+ "</a><li/>";
			pageHtml = pageHtml + "<li><a href=\"\" onClick=\"setWinnerPage("
					+ (index + 1) + ");return false;\">Next</a><li/>";
		} else if (index == pageMax - 1) { // When on the last
			pageHtml = pageHtml + "<li><a href=\"\" onClick=\"setWinnerPage("
					+ (index - 1) + ");return false;\">Previous</a><li/>";
			if (index - 4 >= 0) {
				pageHtml = pageHtml
						+ "<li><a href=\"\" onClick=\"setWinnerPage("
						+ (index - 4) + ");return false;\">" + (index - 3)
						+ "</a><li/>";
			}
			if (index - 3 >= 0) {
				pageHtml = pageHtml
						+ "<li><a href=\"\" onClick=\"setWinnerPage("
						+ (index - 3) + ");return false;\">" + (index - 2)
						+ "</a><li/>";
			}
			pageHtml = pageHtml + "<li><a href=\"\" onClick=\"setWinnerPage("
					+ (index - 2) + ");return false;\">" + (index - 1)
					+ "</a><li/>";
			pageHtml = pageHtml + "<li><a href=\"\" onClick=\"setWinnerPage("
					+ (index - 1) + ");return false;\">" + (index)
					+ "</a><li/>";
			pageHtml = pageHtml + "<li><a href=\"\" class=\"selected\">"
					+ (index + 1) + "</a><li/>";
		} else { // Rest of the case in the middle
			pageHtml = pageHtml + "<li><a href=\"\" onClick=\"setWinnerPage("
					+ (index - 1) + ");return false;\">Previous</a><li/>";
			pageHtml = pageHtml + "<li><a href=\"\" onClick=\"setWinnerPage("
					+ (index - 2) + ");return false;\">" + (index - 1)
					+ "</a><li/>";
			pageHtml = pageHtml + "<li><a href=\"\" onClick=\"setWinnerPage("
					+ (index - 1) + ");return false;\">" + (index)
					+ "</a><li/>";
			pageHtml = pageHtml + "<li><a href=\"\" class=\"selected\">"
					+ (index + 1) + "</a><li/>";
			pageHtml = pageHtml + "<li><a href=\"\" onClick=\"setWinnerPage("
					+ (index + 1) + ");return false;\">" + (index + 2)
					+ "</a><li/>";
			pageHtml = pageHtml + "<li><a href=\"\" onClick=\"setWinnerPage("
					+ (index + 2) + ");return false;\">" + (index + 3)
					+ "</a><li/>";
			if (pageMax - 3 > index) {
				pageHtml = pageHtml + "...";
				pageHtml = pageHtml
						+ "<li><a href=\"\" onClick=\"setWinnerPage("
						+ (pageMax - 1) + ");return false;\">" + (pageMax)
						+ "</a><li/>";
			}

			pageHtml = pageHtml + "<li><a href=\"\" onClick=\"setWinnerPage("
					+ (index + 1) + ");return false;\">Next</a><li/>";
		}
	}

	setWinnersHistory(index, pageHtml);
	document.getElementById("winners-history").innerHTML = winnersHistory;
}

function setWinnerPage(index) {
	setPageIndex(index);
    setIframeHeight();
}

function winnerObject(headlineKey, date, introKey, interviewKey, footerKey,
		resourceKey) {
	this.headlineKey = headlineKey;
	this.date = date;
	this.introKey = introKey;
	this.interviewKey = interviewKey;
	this.footerKey = footerKey;
	this.resourceKey = resourceKey;
}

// div winners-history
var winnersHistory;

// get list of winners for a specific page
function setWinnersHistory(index, footerHtml) {

	var min = pageSize * index;
	var max = pageSize * (index + 1);

	if (max > winnersArray.length)
		max = winnersArray.length;

	winnersHistory =

	"<h3 class=\"common-table-header\">" + lotteryWinnersTableHeader + "</h3>"
			+ "<table border=\"0\" cellpadding=\"0\" cellspacing=\"0\"> "
			+ "<thead>" + "<tr> " + "	<th width=\"7\"></th> " + "	<th>"
			+ lotteryWinnersTableColumnWinner + "</th> "
			+ "	<th colspan=\"2\">" + lotteryWinnersTableColumnDate + "</th> "
			+ "</tr> " + "</thead> " + "<tfoot> " + "	<td colspan=\"4\"> "
			+ "		<ul id=\"winner-history-footer\"> " + footerHtml + "		</ul> "
			+ "	</td> " + "</tfoot> ";

	if (winnersArray != null) {
		if (winnersArray.length == 0) {
			winnersHistory += "<tr><td class=\"table-margin\" colspan=\"5\">"
					+ winnersTableNoWinnerText + "</td></tr>";
		}

		for (var i = min; i < max; i++) {

			winnersHistory += "<tr id=\"winner-row-id-"
					+ i
					+ "-s\" onclick=\"openSuccessStoriesDetails(\'"
					+ escape(winnersArray[i].headlineKey)
					+ "\',"
					+ "\'"
					+ winnersArray[i].date
					+ "\',"
					+ "\'"
					+ escape(winnersArray[i].introKey)
					+ "\',"
					+ "\'"
					+ escape(winnersArray[i].interviewKey)
					+ "\',"
					+ "\'"
					+ escape(winnersArray[i].footerKey)
					+ "\',"
					+ "\'"
					+ winnersArray[i].resourceKey
					+ "\',"
					+ i
					+ ");return false;\">"
					+ "	<td align=\"right\" width=\"7\"><img id=\"winner-arrow-id-"
					+ i
					+ '-s" width="7" height="7" alt="" src="'
					+ navigation.staticURL('img/arrow-right.gif') + '" style="display: none;" /></td>'
					+ '	<td><a href="#">'
					+ winnersArray[i].headlineKey
					+ "</a></td>"
					+ "	<td>"
					+ winnersArray[i].date
					+ "</td>"
					+ "	<td><a href=\"\" class=\"ui-button size-30 color-primary\" onclick=\"openSuccessStoriesDetails(\'"
					+ escape(winnersArray[i].headlineKey) + "\'," + "\'"
					+ winnersArray[i].date + "\'," + "\'"
					+ escape(winnersArray[i].introKey) + "\'," + "\'"
					+ escape(winnersArray[i].interviewKey) + "\'," + "\'"
					+ escape(winnersArray[i].footerKey) + "\'," + "\'"
					+ winnersArray[i].resourceKey + "\'," + i
					+ ");return false;\">" + "	<span>"
					+ lotteryButtonReadInterview + "</span></a></td>" + "</tr>";
		}
	}

	winnersHistory += "</table>";
}
// End Methods for winners tab

// check if element exists in array
function belongsInArray(elem, array) {
	for (var x = 0; x <= array.length; x++) {
		if (array[x] == elem)
			return true;
	}
	return false;
}
// **********************************************************************************************************
// * returns potential lotteries random subset *
// * returned values are randomized subset indexes (sorted in asendiong order) *
// * of existing potential lottery list that is already sorted by next drawing
// date in ascending order *
// * ie: *
// * - 0,1,2,3,4,5,6,7,9 <-- indexes of potential lottery *
// * lets say randomized 4 values are 9,2,1,4, then sort them and result is
// 1,2,4,9 *
// * randomized array doesn't return index of selected lottery *
// * (since it is selected it is not in the list of potential lotteries) *
// **********************************************************************************************************
function randomizePotentialLotteries(lotteryId) {
	var randomnumber;

	// implement set in javascript since default doesn't exist
	var set = {};

	var counter = 0;

	// potential lotteries random subset :(
	var randomPotentialArray = new Array();

	// max number of elements in potential list
	// can be smaller than max_potential_list
	// if number of existing active lotteries is
	// smaller than pre-set potential lottery list size
	var max;

	if (potArray.length <= max_potential_list)
		max = potArray.length - 1;
	else
		max = max_potential_list;

	// get in endless loop if not only one existing lottery
	// in that case calculation is not needed, since potential
	// list will be empty
    var maximumNumberOfLoops = max_potential_list;
	while (1 > 0 && potArray.length > 1) {
        maximumNumberOfLoops--;
		randomnumber = Math.floor(Math.random() * potArray.length);

		// don't store current selected lottery in a potential list
		if (potArray[randomnumber] == lotteryId && maximumNumberOfLoops > 0)
			continue;

		set[randomnumber] = true;

		randomnumber = Math.floor(Math.random() * potArray.length);

		for (var x in set) {
			counter++;
		}

		if (counter >= max) {
			for ( var x in set) {
				randomPotentialArray.push(x);
			}
			break;
		} else
			counter = 0;

        if (maximumNumberOfLoops < 0) {
            for ( var x in set) {
                randomPotentialArray.push(x);
            }
            break;
        }

	}

	randomPotentialArray.sort(function(a, b) {
		return a - b;
	});

	return randomPotentialArray;
}

// get bonus price for each bonus from map
function openBonusMap(bonusId) {
	if (bonusMap[bonusId] != undefined)
		openBonusDetails(bonusId, bonusMap[bonusId]);
}

function lotteryObject(lotteryId, ticketPrice, eurPriceList, nextDrawDate,
		timeConst, lotteryName, lotteryDesc, largeImg, itemPrizeList,
		itemPrizeNameList, winValue, isManual) {
	this.lotteryId = lotteryId;
	this.ticketPrice = ticketPrice;
	this.eurPriceList = eurPriceList;
	this.nextDrawDate = nextDrawDate;
	this.timeConst = timeConst;
	this.lotteryName = lotteryName;
	this.lotteryDesc = lotteryDesc;
	this.largeImg = largeImg;
	this.itemPrizeList = itemPrizeList;
	this.itemPrizeNameList = itemPrizeNameList;
    this.winValue = winValue;
    this.isManual = isManual;
}

function openLotteryMap(lotteryId) {
	if (lotteryMap[lotteryId] != undefined)
		openLotteryDetails(lotteryMap[lotteryId].lotteryId,
				lotteryMap[lotteryId].ticketPrice,
				lotteryMap[lotteryId].eurPriceList,
				lotteryMap[lotteryId].nextDrawDate,
				lotteryMap[lotteryId].timeConst,
				lotteryMap[lotteryId].lotteryName,
				lotteryMap[lotteryId].lotteryDesc,
				lotteryMap[lotteryId].largeImg,
				lotteryMap[lotteryId].itemPrizeList,
				lotteryMap[lotteryId].itemPrizeNameList,
				lotteryMap[lotteryId].winValue,
                lotteryMap[lotteryId].isManual
        );
}
;
